import axios from 'axios';
import React, { Component } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { BASEURL } from '../Config';

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state={}
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSubmit() {
        let data = this.state;
        axios.post(`${BASEURL}/api/v1/contact/create`, data)
        .then(res => {
            if(res.status === 200) {
                console.log('res.data', res.data);
                
            }
        })
    }

    render() {
        return (
            <div className="site-wrap">
                <Header page={'contact'} />
                {/* <div className="site-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h2 className="h3 mb-3 text-black">Get In Touch</h2>
                            </div>
                            <div className="col-md-12">
                                <form action="#" method="post">
                                    <div className="p-3 p-lg-5 border">
                                        <div className="form-group row">
                                            <div className="col-md-6">
                                                <label htmlFor="c_fname" className="text-black">First Name <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" id="c_fname" name="fn" onChange={(e) => this.handleChange(e)} />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="c_lname" className="text-black">Last Name <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" id="c_lname" name="ln" onChange={(e) => this.handleChange(e)} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md-12">
                                                <label htmlFor="c_email" className="text-black">Email <span className="text-danger">*</span></label>
                                                <input type="email" className="form-control" id="c_email" name="email" placeholder onChange={(e) => this.handleChange(e)} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md-12">
                                                <label htmlFor="c_mobile" className="text-black">Mobile Number  <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" id="c_mobile" name="phoneNo" onChange={(e) => this.handleChange(e)} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md-12">
                                                <label htmlFor="c_message" className="text-black">Message </label>
                                                <textarea name="msg" id="c_message" cols={30} rows={7} className="form-control" onChange={(e) => this.handleChange(e)} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-lg-12">
                                                <button type="submit" className="btn btn-primary btn-lg btn-block" onClick={() => this.handleSubmit()}>Submit</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><strong className="text-black">Contact Us</strong></div>
                        </div>
                    </div>
                </div>
                <div className="site-section">
                    <div className="container">
                        <div className="row">
                            <div className='textpara col-md-12'>
                                <p>
                                    <strong>We are Happy to Help You!</strong><br/><br/>

                                    <strong>Mail us:</strong><br/><br/>

                                    <strong>For Any Queries:</strong> pelicanpublishinghouse@gmail.com <br/><br/>
                                    <strong>For billing info:</strong> pelicanpublishinghouse@gmail.com<br/><br/>

                                    <strong>Contact Number:</strong><br/><br/>
                                    7207020942<br/><br/>
                                    {/* (MON-SAT: 10 AM - 6:30 PM)<br/><br/> */}

                                    Or contact us at our registered office:
                                    <br/><br/>
                                    <strong>Address:</strong><br/><br/>
                                   
                                    PelicanEduSupply <br/>
                                    C/o Pelican publishing house <br/>
                                    plot no2/b, Hyderabad 500051.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Contact;